import { coinGeckoApi } from '@shared/service'

export const fetchErc20TokenCoinId = async (
  tokenAddress: string
): Promise<string | undefined> => {
  try {
    return await coinGeckoApi.fetchErc20TokenCoinId(tokenAddress)
  } catch {
    // silently fail
  }
}
